import type { ProgramEventListType } from 'models';
import { Col, Row, Tag as TagUI } from 'ui';
import { useGetEventTagsProperties } from 'features/events';

type P = {
  endTime: Date;
  startTime: Date;
  type: ProgramEventListType;
};

const Tag = ({ endTime, startTime, type }: P) => {
  const tags = useGetEventTagsProperties({ endTime, eventType: type, startTime, status: 'published' });

  return (
    <Row gutter="ms">
      {tags.map(({ key, ...tagProperties }) => (
        <Col key={key}>
          <TagUI {...tagProperties} />
        </Col>
      ))}
    </Row>
  );
};

export default Tag;
